import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const AttrLightsIcon = React.memo<IconProps>(({ 
  className = '',
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth
}) => (
  <BaseIcon
    className={className}
    size={size}
    color={color}
    onClick={onClick}
    viewBox="0 0 24 24"
    strokeWidth={strokeWidth}
  >
    <path d="M16.08 6.69C15.54 6.53 14.99 6.84 14.84 7.37L14.5 8.55H9.51001L9.17001 7.37C9.02001 6.84 8.46001 6.54 7.93001 6.69C7.40001 6.84 7.10001 7.4 7.25001 7.93L8.91001 13.63C9.06001 14.16 9.63001 14.46 10.15 14.31C10.68 14.16 10.98 13.6 10.83 13.07L10.1 10.55H13.92L13.19 13.07C13.04 13.6 13.34 14.16 13.87 14.31C14.39 14.46 14.96 14.16 15.11 13.63L16.77 7.93C16.92 7.4 16.62 6.85 16.09 6.69H16.08Z" fill={color}/>
    <path d="M12 0C6.76 0 2.5 4.26 2.5 9.5C2.5 12.55 3.98 15.43 6.46 17.21C7.01 17.6 7.39 18.23 7.55 18.99L8.02 21.21C8.12 21.67 8.53 22 9 22H10V23C10 23.55 10.45 24 11 24H13C13.55 24 14 23.55 14 23V22H15C15.48 22 15.89 21.66 15.98 21.2L16.42 19.01C16.57 18.26 16.95 17.63 17.5 17.24C20 15.46 21.5 12.57 21.5 9.5C21.5 4.26 17.24 0 12 0ZM16.34 15.61C15.38 16.29 14.71 17.36 14.46 18.61L14.18 20H9.81L9.51 18.58C9.25 17.34 8.58 16.27 7.63 15.59C5.67 14.18 4.5 11.91 4.5 9.5C4.5 5.36 7.86 2 12 2C16.14 2 19.5 5.36 19.5 9.5C19.5 11.92 18.32 14.2 16.34 15.61Z" fill={color}/>
  </BaseIcon>
));

AttrLightsIcon.displayName = 'AttrLightsIcon';
